(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire44e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire44e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hvZMf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cc05409771aeea55$export$71511d61b312f219; });

var $2zPWk = parcelRequire("2zPWk");

var $91t4N = parcelRequire("91t4N");

var $eTJIp = parcelRequire("eTJIp");

var $537SV = parcelRequire("537SV");
function $cc05409771aeea55$export$71511d61b312f219(arr) {
    return (0, $2zPWk._)(arr) || (0, $91t4N._)(arr) || (0, $537SV._)(arr) || (0, $eTJIp._)();
}

});
parcelRegister("2zPWk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1e0723cca33e235d$export$71511d61b312f219; });

var $a3d64 = parcelRequire("a3d64");
function $1e0723cca33e235d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $a3d64._)(arr);
}

});
parcelRegister("a3d64", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $751457f6259d374a$export$71511d61b312f219; });
function $751457f6259d374a$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("91t4N", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $691ac3035b950bbe$export$71511d61b312f219; });
function $691ac3035b950bbe$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("eTJIp", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ad89a9d214926ab2$export$71511d61b312f219; });
function $ad89a9d214926ab2$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("537SV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3ad35952737de5da$export$71511d61b312f219; });

var $a3d64 = parcelRequire("a3d64");
function $3ad35952737de5da$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $a3d64._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $a3d64._)(o, minLen);
}

});


parcelRegister("LCZef", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $5e37999a99b848cc$export$57bf213be019eeb0; });
$parcel$export(module.exports, "hide", function () { return $5e37999a99b848cc$export$fe8985bb6374093c; });
$parcel$export(module.exports, "fadeIn", function () { return $5e37999a99b848cc$export$82e6205b15e6c637; });
$parcel$export(module.exports, "fadeOut", function () { return $5e37999a99b848cc$export$c091916f1530334c; });
$parcel$export(module.exports, "slideUp", function () { return $5e37999a99b848cc$export$deed561b1a0ff1ea; });
$parcel$export(module.exports, "slideDown", function () { return $5e37999a99b848cc$export$abdd11a06a163232; });
$parcel$export(module.exports, "slideIn", function () { return $5e37999a99b848cc$export$d08c54023c399c9c; });
$parcel$export(module.exports, "slideOut", function () { return $5e37999a99b848cc$export$388d063d19975bb; });
$parcel$export(module.exports, "isVisible", function () { return $5e37999a99b848cc$export$795910f5f15a9633; });

var $hvZMf = parcelRequire("hvZMf");
var $5e37999a99b848cc$export$57bf213be019eeb0 = function(element, options) {
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;
        (options === null || options === void 0 ? void 0 : options.addClasses) && (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        (options === null || options === void 0 ? void 0 : options.removeClasses) && (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        element.offsetHeight;
    }
};
var $5e37999a99b848cc$export$fe8985bb6374093c = function(element, options) {
    if (element) {
        var _element_classList, _element_classList1;
        element.style.display = 'none';
        (options === null || options === void 0 ? void 0 : options.addClasses) && (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        (options === null || options === void 0 ? void 0 : options.removeClasses) && (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
    }
};
var $5e37999a99b848cc$export$82e6205b15e6c637 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element && ((options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) === undefined || (options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) && window.getComputedStyle(element).display === 'none')) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.opacity = '0';
        element.style.visibility = 'hidden';
        element.style.display = display === 'none' ? 'block' : display;
        // Force CSS Reflow
        element.offsetHeight;
        element.style.transition = "opacity ".concat(duration, "ms linear");
        element.style.visibility = 'visible';
        element.style.opacity = '1';
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.removeProperty('opacity');
            element.style.removeProperty('visibility');
            element.style.removeProperty('transition');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$c091916f1530334c = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element && ((options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) === undefined || (options === null || options === void 0 ? void 0 : options.animateOnlyIfToggled) && window.getComputedStyle(element).display !== 'none')) {
        var _element_classList, _element_classList1;
        element.style.transition = "opacity ".concat(duration, "ms linear");
        element.style.opacity = '0';
        // Force CSS Reflow
        element.offsetHeight;
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.display = 'none';
            element.style.removeProperty('transition');
            element.style.removeProperty('opacity');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$75d3d2c72ecccf9b = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        if (window.getComputedStyle(element).display === 'none') return $5e37999a99b848cc$export$82e6205b15e6c637(element, duration, options);
        else return $5e37999a99b848cc$export$c091916f1530334c(element, duration, options);
    }
};
var $5e37999a99b848cc$export$deed561b1a0ff1ea = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = element.offsetHeight + 'px';
        // Force CSS Reflow
        element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$abdd11a06a163232 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;
        var height = element.offsetHeight;
        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        // Force CSS Reflow
        element.offsetHeight;
        element.style.boxSizing = 'border-box';
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_callback;
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$715de50cedc228a8 = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        if (window.getComputedStyle(element).display === 'none') return $5e37999a99b848cc$export$abdd11a06a163232(element, duration, options);
        else return $5e37999a99b848cc$export$deed561b1a0ff1ea(element, duration, options);
    }
};
var $5e37999a99b848cc$export$d08c54023c399c9c = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        element.style.removeProperty('display');
        var display = window.getComputedStyle(element).display;
        element.style.left = "-".concat(element.offsetWidth, "px");
        element.style.display = 'none';
        element.style.removeProperty('display');
        element.style.left = "-".concat(element.offsetWidth, "px");
        element.style.display = display === 'none' ? 'block' : display;
        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = (options === null || options === void 0 ? void 0 : options.distance) !== undefined ? "".concat(options.distance, "px") : '';
        document.documentElement.classList.add('mobile-behind');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _element_querySelector, _options_callback;
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            (_element_querySelector = element.querySelector('a, button')) === null || _element_querySelector === void 0 ? void 0 : _element_querySelector.focus();
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$388d063d19975bb = function(element) {
    var duration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300, options = arguments.length > 2 ? arguments[2] : void 0;
    if (element) {
        var _element_classList, _element_classList1;
        var distance = "-".concat(window.getComputedStyle(element).width);
        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = distance;
        document.documentElement.classList.remove('mobile-behind');
        if ((options === null || options === void 0 ? void 0 : options.addClasses) && !options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
        if ((options === null || options === void 0 ? void 0 : options.removeClasses) && !options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        setTimeout(function() {
            var _element_classList, _element_classList1;
            var _options_toggle, _options_callback;
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            element.style.display = 'none';
            options === null || options === void 0 ? void 0 : (_options_toggle = options.toggle) === null || _options_toggle === void 0 ? void 0 : _options_toggle.focus();
            options === null || options === void 0 ? void 0 : (_options_callback = options.callback) === null || _options_callback === void 0 ? void 0 : _options_callback.call(options);
            if ((options === null || options === void 0 ? void 0 : options.addClasses) && options.addClassesAfterDuration) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.addClasses));
            if ((options === null || options === void 0 ? void 0 : options.removeClasses) && options.removeClassesAfterDuration) (_element_classList1 = element.classList).remove.apply(_element_classList1, (0, $hvZMf._)(options.removeClasses));
        }, duration);
    }
};
var $5e37999a99b848cc$export$795910f5f15a9633 = function(element) {
    if (!element || !element.isConnected) return false;
    if (element.getClientRects().length === 0) return false;
    var style = getComputedStyle(element);
    if (style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    var rect = element.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    if (style.opacity === '0') return false;
    return true;
};

});

parcelRegister("1P2tS", function(module, exports) {

$parcel$export(module.exports, "getCookie", function () { return $9a0b725451b84148$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "deleteCookie", function () { return $9a0b725451b84148$export$b43e45590305ffaa; });
var $9a0b725451b84148$export$4be65e66cfa2648a = function(cookieName) {
    var _document_cookie_split_map_find;
    return (_document_cookie_split_map_find = document.cookie.split(';').map(function(cookie) {
        return cookie.trim().split('=');
    }).find(function(cookie) {
        return (cookie === null || cookie === void 0 ? void 0 : cookie[0]) === cookieName;
    })) === null || _document_cookie_split_map_find === void 0 ? void 0 : _document_cookie_split_map_find[1];
};
var $9a0b725451b84148$export$96746799f34533a4 = function(cookieName, cookieValue) {
    var maxAge = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2592000, sameSite = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'Strict', path = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : '/';
    document.cookie = "".concat(cookieName, "=").concat(cookieValue, ";Max-Age=").concat(maxAge, ";SameSite=").concat(sameSite, ";Path=").concat(path);
};
var $9a0b725451b84148$export$b43e45590305ffaa = function(cookieName) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '/';
    document.cookie = "".concat(cookieName, "=; Path=").concat(path, "; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
};

});

parcelRegister("jm8jg", function(module, exports) {

$parcel$export(module.exports, "createElement", function () { return $9a5297f5112e9cd2$export$c8a8987d4410bf2d; });

var $hvZMf = parcelRequire("hvZMf");
var $9a5297f5112e9cd2$export$c8a8987d4410bf2d = function(tagName, options) {
    var _element_classList;
    var element = document.createElement(tagName);
    if (options === null || options === void 0 ? void 0 : options.id) element.id = options.id;
    if (options === null || options === void 0 ? void 0 : options.classes) (_element_classList = element.classList).add.apply(_element_classList, (0, $hvZMf._)(options.classes));
    if ((options === null || options === void 0 ? void 0 : options.href) && 'href' in element) element.href = options.href;
    if ((options === null || options === void 0 ? void 0 : options.src) && 'src' in element) element.src = options.src;
    if (options === null || options === void 0 ? void 0 : options.style) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(options.style)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (options.style[key] !== undefined) element.style[key] = options.style[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                    _iterator["return"]();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if ((options === null || options === void 0 ? void 0 : options.type) && 'type' in element) element.type = options.type;
    if (options === null || options === void 0 ? void 0 : options.ariaControls) element.setAttribute('aria-controls', options.ariaControls);
    if ((options === null || options === void 0 ? void 0 : options.ariaHidden) !== undefined) element.ariaHidden = options.ariaHidden;
    if ((options === null || options === void 0 ? void 0 : options.ariaExpanded) !== undefined) element.ariaExpanded = options.ariaExpanded;
    if ((options === null || options === void 0 ? void 0 : options.tabIndex) !== undefined) element.tabIndex = options.tabIndex;
    if (options === null || options === void 0 ? void 0 : options.innerText) element.innerText = options.innerText;
    if ((options === null || options === void 0 ? void 0 : options.value) && 'value' in element) element.value = options.value;
    if (options === null || options === void 0 ? void 0 : options.title) element.title = options.title;
    if ((options === null || options === void 0 ? void 0 : options.alt) && 'alt' in element) element.alt = options.alt;
    if ((options === null || options === void 0 ? void 0 : options.target) && 'target' in element) element.target = options.target;
    if (options === null || options === void 0 ? void 0 : options.properties) {
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = options.properties[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var property = _step1.value;
                if (property.key && property.key in element) element[property.key] = property.value;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                    _iterator1["return"]();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (options === null || options === void 0 ? void 0 : options.role) element.role = options.role;
    if (options === null || options === void 0 ? void 0 : options.ariaPosInSet) element.ariaPosInSet = options.ariaPosInSet;
    if ((options === null || options === void 0 ? void 0 : options.disabled) && 'disabled' in element) element.disabled = element.disabled;
    if (options === null || options === void 0 ? void 0 : options.children) {
        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
        try {
            for(var _iterator2 = options.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                var child = _step2.value;
                if (child !== null) element.appendChild(child);
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                    _iterator2["return"]();
                }
            } finally{
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
    if (options === null || options === void 0 ? void 0 : options.handlers) try {
        for(var _iterator3 = options.handlers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
            var handler = _step3.value;
            element.addEventListener(handler.type, handler.listener);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
            }
        } finally{
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
    return element;
};

});


var $hvZMf = parcelRequire("hvZMf");

var $LCZef = parcelRequire("LCZef");

var $1P2tS = parcelRequire("1P2tS");

var $jm8jg = parcelRequire("jm8jg");
var $0439bc9e67631b60$var$_document_querySelector;
var $0439bc9e67631b60$var$_document_querySelector_content;
var $0439bc9e67631b60$var$siteControlId = ($0439bc9e67631b60$var$_document_querySelector_content = ($0439bc9e67631b60$var$_document_querySelector = document.querySelector('meta[name=sitecontrolID]')) === null || $0439bc9e67631b60$var$_document_querySelector === void 0 ? void 0 : $0439bc9e67631b60$var$_document_querySelector.content) !== null && $0439bc9e67631b60$var$_document_querySelector_content !== void 0 ? $0439bc9e67631b60$var$_document_querySelector_content : '';
var $0439bc9e67631b60$var$globalAlertsContainer = document.querySelector('header .global-alerts');
var $0439bc9e67631b60$var$alerts = document.querySelectorAll('header .global-alerts .alert');
if ($0439bc9e67631b60$var$globalAlertsContainer && $0439bc9e67631b60$var$alerts.length > 0) {
    var $0439bc9e67631b60$var$_viewAlertsButton_dataset;
    var $0439bc9e67631b60$var$header = document.querySelector('header');
    var $0439bc9e67631b60$var$innerAlertsContainer = $0439bc9e67631b60$var$globalAlertsContainer.querySelector('.alerts');
    var $0439bc9e67631b60$var$viewAlertsButton = $0439bc9e67631b60$var$globalAlertsContainer.querySelector('.view-alerts');
    var $0439bc9e67631b60$var$alertCount = $0439bc9e67631b60$var$globalAlertsContainer.querySelector('.alert-count');
    var $0439bc9e67631b60$var$viewIcon = $0439bc9e67631b60$var$globalAlertsContainer.querySelector('.view-icon');
    var $0439bc9e67631b60$var$viewText = $0439bc9e67631b60$var$globalAlertsContainer.querySelector('.view-text');
    var $0439bc9e67631b60$var$_viewAlertsButton_querySelector;
    var $0439bc9e67631b60$var$screenReaderText = ($0439bc9e67631b60$var$_viewAlertsButton_querySelector = $0439bc9e67631b60$var$viewAlertsButton === null || $0439bc9e67631b60$var$viewAlertsButton === void 0 ? void 0 : $0439bc9e67631b60$var$viewAlertsButton.querySelector('.sr-only')) !== null && $0439bc9e67631b60$var$_viewAlertsButton_querySelector !== void 0 ? $0439bc9e67631b60$var$_viewAlertsButton_querySelector : null;
    if ($0439bc9e67631b60$var$viewAlertsButton === null || $0439bc9e67631b60$var$viewAlertsButton === void 0 ? void 0 : ($0439bc9e67631b60$var$_viewAlertsButton_dataset = $0439bc9e67631b60$var$viewAlertsButton.dataset) === null || $0439bc9e67631b60$var$_viewAlertsButton_dataset === void 0 ? void 0 : $0439bc9e67631b60$var$_viewAlertsButton_dataset.alertids) {
        var $0439bc9e67631b60$var$alertIds = $0439bc9e67631b60$var$viewAlertsButton.dataset.alertids.split('|');
        var $0439bc9e67631b60$var$_getCookie;
        var $0439bc9e67631b60$var$dismissedAlertsCookie = ($0439bc9e67631b60$var$_getCookie = (0, $1P2tS.getCookie)("Sonoma_".concat($0439bc9e67631b60$var$siteControlId, "_Alerts"))) !== null && $0439bc9e67631b60$var$_getCookie !== void 0 ? $0439bc9e67631b60$var$_getCookie : '';
        var $0439bc9e67631b60$var$dismissedAlerts = [];
        var $0439bc9e67631b60$var$dialogOpened = false;
        var $0439bc9e67631b60$var$newAlerts = 0;
        if ($0439bc9e67631b60$var$dismissedAlertsCookie) {
            var $0439bc9e67631b60$var$splitStatusAlerts = $0439bc9e67631b60$var$dismissedAlertsCookie.split(':');
            if ($0439bc9e67631b60$var$splitStatusAlerts.length > 0) {
                $0439bc9e67631b60$var$dialogOpened = $0439bc9e67631b60$var$splitStatusAlerts[0] === 'opened';
                if ($0439bc9e67631b60$var$splitStatusAlerts[1]) $0439bc9e67631b60$var$dismissedAlerts = $0439bc9e67631b60$var$splitStatusAlerts[1].split('|');
            }
        }
        var $0439bc9e67631b60$var$newAlertIndicator = (0, $jm8jg.createElement)('span', {
            classes: [
                'new-alert-indicator'
            ],
            innerText: 'New'
        });
        $0439bc9e67631b60$var$alertIds.forEach(function(alertId) {
            if (!$0439bc9e67631b60$var$dismissedAlerts.includes(alertId)) {
                $0439bc9e67631b60$var$newAlerts++;
                var alertLink = document.getElementById(alertId);
                alertLink === null || alertLink === void 0 ? void 0 : alertLink.classList.add('new-alert');
                alertLink === null || alertLink === void 0 ? void 0 : alertLink.after($0439bc9e67631b60$var$newAlertIndicator.cloneNode(true));
            }
        });
        if ($0439bc9e67631b60$var$alertCount && $0439bc9e67631b60$var$viewIcon && $0439bc9e67631b60$var$viewText && $0439bc9e67631b60$var$viewAlertsButton && $0439bc9e67631b60$var$innerAlertsContainer) {
            if ($0439bc9e67631b60$var$newAlerts > 0) {
                $0439bc9e67631b60$var$alertCount.innerText = $0439bc9e67631b60$var$newAlerts > 1 ? "".concat($0439bc9e67631b60$var$newAlerts, " new alerts") : '1 new alert';
                $0439bc9e67631b60$var$viewIcon.classList.add('hidden');
            } else {
                $0439bc9e67631b60$var$alertCount.innerText = $0439bc9e67631b60$var$alertIds.length > 1 ? "".concat($0439bc9e67631b60$var$alertIds.length, " alerts") : '1 alert';
                $0439bc9e67631b60$var$globalAlertsContainer.classList.add('viewed');
                $0439bc9e67631b60$var$viewText.classList.add('hidden');
            }
            if ($0439bc9e67631b60$var$dialogOpened) {
                var $0439bc9e67631b60$var$_viewAlertsButton_querySelector1, $0439bc9e67631b60$var$_viewAlertsButton_querySelector2;
                $0439bc9e67631b60$var$globalAlertsContainer.classList.remove('closed');
                $0439bc9e67631b60$var$globalAlertsContainer.classList.add('opened', 'viewed');
                $0439bc9e67631b60$var$viewAlertsButton.ariaExpanded = 'true';
                ($0439bc9e67631b60$var$_viewAlertsButton_querySelector1 = $0439bc9e67631b60$var$viewAlertsButton.querySelector('i')) === null || $0439bc9e67631b60$var$_viewAlertsButton_querySelector1 === void 0 ? void 0 : $0439bc9e67631b60$var$_viewAlertsButton_querySelector1.classList.remove('hidden');
                ($0439bc9e67631b60$var$_viewAlertsButton_querySelector2 = $0439bc9e67631b60$var$viewAlertsButton.querySelector('.view-text')) === null || $0439bc9e67631b60$var$_viewAlertsButton_querySelector2 === void 0 ? void 0 : $0439bc9e67631b60$var$_viewAlertsButton_querySelector2.classList.add('hidden');
                if ($0439bc9e67631b60$var$screenReaderText) $0439bc9e67631b60$var$screenReaderText.innerText = 'Hide Alerts';
                (0, $LCZef.show)($0439bc9e67631b60$var$innerAlertsContainer);
                var $0439bc9e67631b60$var$headerHeight = $0439bc9e67631b60$var$header ? parseInt(window.getComputedStyle($0439bc9e67631b60$var$header).height.replace('px', '')) : 0;
                if (window.innerWidth < 395 && window.innerHeight - 44 - $0439bc9e67631b60$var$headerHeight < $0439bc9e67631b60$var$innerAlertsContainer.scrollHeight) {
                    $0439bc9e67631b60$var$innerAlertsContainer.style.height = "".concat(window.innerHeight - 44 - $0439bc9e67631b60$var$headerHeight, "px");
                    $0439bc9e67631b60$var$innerAlertsContainer.style.overflowY = 'scroll';
                    document.documentElement.classList.add('behind');
                } else $0439bc9e67631b60$var$innerAlertsContainer.style.removeProperty('height');
            }
        }
        if ($0439bc9e67631b60$var$alertCount && $0439bc9e67631b60$var$viewIcon && $0439bc9e67631b60$var$viewText && $0439bc9e67631b60$var$viewAlertsButton && $0439bc9e67631b60$var$innerAlertsContainer) {
            var $0439bc9e67631b60$var$alertLinks = (0, $hvZMf._)($0439bc9e67631b60$var$innerAlertsContainer.querySelectorAll('.alert-link'));
            var $0439bc9e67631b60$var$setAlertsCookie = function() {
                if ($0439bc9e67631b60$var$globalAlertsContainer.classList.contains('viewed') && $0439bc9e67631b60$var$globalAlertsContainer.classList.contains('opened')) document.cookie = "Sonoma_".concat($0439bc9e67631b60$var$siteControlId, "_Alerts=closed:").concat($0439bc9e67631b60$var$viewAlertsButton.dataset.alertids, ";Max-Age=2592000;SameSite=Strict;Path=/;");
                else if ($0439bc9e67631b60$var$globalAlertsContainer.classList.contains('viewed')) document.cookie = "Sonoma_".concat($0439bc9e67631b60$var$siteControlId, "_Alerts=opened:").concat($0439bc9e67631b60$var$viewAlertsButton.dataset.alertids, ";Max-Age=2592000;SameSite=Strict;Path=/;");
                else if ($0439bc9e67631b60$var$globalAlertsContainer.classList.contains('closed')) {
                    var alertsSeenString = (0, $1P2tS.getCookie)("Sonoma_".concat($0439bc9e67631b60$var$siteControlId, "_Alerts"));
                    if (alertsSeenString) {
                        alertsSeenString = alertsSeenString.replace('opened:', '').replace('closed:', '');
                        document.cookie = "Sonoma_".concat($0439bc9e67631b60$var$siteControlId, "_Alerts=opened;").concat(alertsSeenString, ";Max-Age=2592000;SameSite=Strict;Path=/;");
                    } else document.cookie = "Sonoma_".concat($0439bc9e67631b60$var$siteControlId, "_Alerts=opened;Max-Age=2592000;SameSite=Strict;Path=/;");
                }
            };
            var $0439bc9e67631b60$var$hideAlertsList = function() {
                $0439bc9e67631b60$var$globalAlertsContainer.classList.remove('closed');
                $0439bc9e67631b60$var$globalAlertsContainer.classList.add('opened');
                $0439bc9e67631b60$var$viewAlertsButton.disabled = true;
                (0, $LCZef.slideUp)($0439bc9e67631b60$var$innerAlertsContainer, 200, {
                    callback: function() {
                        $0439bc9e67631b60$var$innerAlertsContainer.style.removeProperty('height');
                        document.documentElement.classList.remove('behind');
                        $0439bc9e67631b60$var$globalAlertsContainer.classList.add('viewed');
                        $0439bc9e67631b60$var$viewAlertsButton.ariaExpanded = 'false';
                        $0439bc9e67631b60$var$viewAlertsButton.disabled = false;
                        $0439bc9e67631b60$var$viewIcon.classList.remove('hidden');
                        $0439bc9e67631b60$var$viewText.classList.add('hidden');
                        if ($0439bc9e67631b60$var$screenReaderText) $0439bc9e67631b60$var$screenReaderText.innerText = 'Show All Alerts';
                        $0439bc9e67631b60$var$viewAlertsButton.focus();
                        $0439bc9e67631b60$var$globalAlertsContainer.classList.add('closed');
                        $0439bc9e67631b60$var$globalAlertsContainer.classList.remove('opened');
                    }
                });
            };
            var $0439bc9e67631b60$var$showAlertsList = function(focusElement) {
                $0439bc9e67631b60$var$viewAlertsButton.disabled = true;
                $0439bc9e67631b60$var$globalAlertsContainer.classList.remove('closed');
                $0439bc9e67631b60$var$globalAlertsContainer.classList.add('opened', 'viewed');
                (0, $LCZef.slideDown)($0439bc9e67631b60$var$innerAlertsContainer, 200, {
                    callback: function() {
                        var headerHeight = $0439bc9e67631b60$var$header != null ? parseInt(window.getComputedStyle($0439bc9e67631b60$var$header).height.replace('px', '')) : 0;
                        if (window.innerWidth < 395 && window.innerHeight - 44 - headerHeight < $0439bc9e67631b60$var$innerAlertsContainer.scrollHeight) {
                            $0439bc9e67631b60$var$innerAlertsContainer.style.height = "".concat(window.innerHeight - 44 - headerHeight, "px");
                            $0439bc9e67631b60$var$innerAlertsContainer.style.overflowY = 'scroll';
                        }
                        $0439bc9e67631b60$var$globalAlertsContainer.classList.add('viewed');
                        $0439bc9e67631b60$var$viewAlertsButton.ariaExpanded = 'true';
                        $0439bc9e67631b60$var$viewAlertsButton.disabled = false;
                        $0439bc9e67631b60$var$viewIcon.classList.remove('hidden');
                        $0439bc9e67631b60$var$viewText.classList.add('hidden');
                        if ($0439bc9e67631b60$var$screenReaderText) $0439bc9e67631b60$var$screenReaderText.innerText = 'Hide Alerts';
                        if (focusElement === 'first') $0439bc9e67631b60$var$alertLinks[0].focus();
                        else $0439bc9e67631b60$var$alertLinks[$0439bc9e67631b60$var$alertLinks.length - 1].focus();
                    }
                });
            };
            $0439bc9e67631b60$var$viewAlertsButton === null || $0439bc9e67631b60$var$viewAlertsButton === void 0 ? void 0 : $0439bc9e67631b60$var$viewAlertsButton.addEventListener('click', function() {
                $0439bc9e67631b60$var$setAlertsCookie();
                if (window.getComputedStyle($0439bc9e67631b60$var$innerAlertsContainer).display !== 'none') $0439bc9e67631b60$var$hideAlertsList();
                else $0439bc9e67631b60$var$showAlertsList('first');
            });
            $0439bc9e67631b60$var$viewAlertsButton === null || $0439bc9e67631b60$var$viewAlertsButton === void 0 ? void 0 : $0439bc9e67631b60$var$viewAlertsButton.addEventListener('keydown', function(event) {
                if (window.getComputedStyle($0439bc9e67631b60$var$innerAlertsContainer).display !== 'none') {
                    if (event.key === 'Escape') $0439bc9e67631b60$var$hideAlertsList();
                    else switch(event.key){
                        case 'ArrowDown':
                            var _innerAlertsContainer_querySelector;
                            event.preventDefault();
                            (_innerAlertsContainer_querySelector = $0439bc9e67631b60$var$innerAlertsContainer.querySelector('.alert-link')) === null || _innerAlertsContainer_querySelector === void 0 ? void 0 : _innerAlertsContainer_querySelector.focus();
                            break;
                        case 'ArrowUp':
                        case 'End':
                            event.preventDefault();
                            $0439bc9e67631b60$var$alertLinks[$0439bc9e67631b60$var$alertLinks.length - 1].focus();
                            break;
                        default:
                            break;
                    }
                } else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                    event.preventDefault();
                    $0439bc9e67631b60$var$setAlertsCookie();
                    $0439bc9e67631b60$var$showAlertsList(event.key === 'ArrowUp' ? 'last' : 'first');
                }
            });
            $0439bc9e67631b60$var$alertLinks.forEach(function(alertLink) {
                return alertLink.addEventListener('keydown', function(event) {
                    var currentLinkIndex = $0439bc9e67631b60$var$alertLinks.indexOf(alertLink);
                    switch(event.key){
                        case 'Escape':
                            $0439bc9e67631b60$var$viewAlertsButton.click();
                            break;
                        case 'ArrowUp':
                            var _alertLinks_;
                            event.preventDefault();
                            if (currentLinkIndex === 0) $0439bc9e67631b60$var$viewAlertsButton.focus();
                            else if ($0439bc9e67631b60$var$alertLinks[currentLinkIndex - 1]) $0439bc9e67631b60$var$alertLinks[currentLinkIndex - 1].focus();
                            else (_alertLinks_ = $0439bc9e67631b60$var$alertLinks[$0439bc9e67631b60$var$alertLinks.length - 1]) === null || _alertLinks_ === void 0 ? void 0 : _alertLinks_.focus();
                            break;
                        case 'ArrowDown':
                            event.preventDefault();
                            if ($0439bc9e67631b60$var$alertLinks[currentLinkIndex + 1]) $0439bc9e67631b60$var$alertLinks[currentLinkIndex + 1].focus();
                            else $0439bc9e67631b60$var$viewAlertsButton.focus();
                            break;
                        case 'Home':
                            event.preventDefault();
                            $0439bc9e67631b60$var$viewAlertsButton.focus();
                            break;
                        case 'End':
                            event.preventDefault();
                            $0439bc9e67631b60$var$alertLinks[$0439bc9e67631b60$var$alertLinks.length - 1].focus();
                            break;
                    }
                });
            });
        }
    } else (0, $1P2tS.deleteCookie)("Sonoma_".concat($0439bc9e67631b60$var$siteControlId, "_Alerts"));
} else (0, $1P2tS.deleteCookie)("Sonoma_".concat($0439bc9e67631b60$var$siteControlId, "_Alerts"));

})();
//# sourceMappingURL=Alerts.js.map
